import { useTranslation } from 'react-i18next'
import SecurityPanel from '../components/security/SecurityPanel'

/** VH-285 — the Security page (/security). */
export default function Security() {
  const { t } = useTranslation()
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{t('secondFactor.page.title')}</h1>
        <p className="text-sm text-gray-500">{t('secondFactor.page.subtitle')}</p>
      </div>
      <SecurityPanel />
    </div>
  )
}
